import Characteristics from "../../commons/components/Characteristics";
import { GridCellProps } from "@progress/kendo-react-grid";

export default function CaracteristiquesCell(props: GridCellProps) {
    return <>
        <td colSpan={1} className="k-table-td" role="gridcell" aria-colindex={12} aria-selected="false" data-grid-col-index="11"><Characteristics prod_num={props.dataItem.prod_num} /></td>
    </>;
}